// Copyright 2018 Sorama B.V.

import { Point2D } from "datatypes/SoramaLocalApi";

export class ArrayToMovingAverageArrayConverter {
    public static movingAverage(arr: Point2D[], range: number): Point2D[] {
        const length: number = arr.length;
        const result: Point2D[] = new Array(length);

        // Check if range is even. If so, make it uneven.
        if (range % 2 == 0) {
            range = range + 1;
        }

        // Divide range by two
        const halfRange = (range - 1) / 2;
        let avg = 0;

        for (let i = 0; i < halfRange; i++) {
            avg += arr[i].y * arr[i].y;
        }

        for (let index = 0; index < length; index++) {
            if (index - halfRange >= 0) {
                const idx = index - halfRange;
                avg -= arr[idx].y * arr[idx].y;
            }

            if (index + halfRange < length) {
                const idx = index + halfRange;
                avg += arr[idx].y * arr[idx].y;
            }

            const start = Math.max(index - halfRange, 0);
            const end = Math.min(index + halfRange, length - 1);
            const count = end - start + 1;
            result[index] = { x: arr[index].x, y: Math.sqrt(avg / count) };
        }

        return result;
    }
}
